export const fnAppName = (idApp) => {
    switch(+idApp){
        case 67:
            return 'SimplitPOS'
        case 89:
            return 'Herramientas fiscales'
        default:
            return ''
    }
}